import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../config/colores'

export function getColumnas (rol) {
  return ([
    {
      name: 'fechaCupo',
      label: 'Fecha',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => {
          return moment(fecha).format('DD-MM-YYYY')
        }
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        setCellProps: () => ({
          style: {
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multi-select',
        display: ((rol && rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR'))
      }
    },
    {
      name: 'cantidadAsignadaNominables',
      label: 'Asignados nominables',
      options: {
        filter: false,
        sort: true,
        total: true,
        totalFloat: 'center',
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'cantidadAsignadaLibres',
      label: 'Asignados libres',
      options: {
        filter: false,
        sort: true,
        total: true,
        totalFloat: 'center',
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'totalAsignados',
      label: 'Total asignados',
      options: {
        filter: false,
        sort: true,
        total: true,
        totalFloat: 'center',
        setCellProps: () => ({
          style: {
            background: '#c0c5e1',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: '#c0c5e1'
          }
        })
      }
    },
    {
      name: 'cantidadNominada',
      label: 'Nominados',
      options: {
        filter: false,
        sort: false,
        total: true,
        totalFloat: 'center',
        tooltipLabel: 'Cantidad de nominados de los cupos asignados nominables',
        customBodyRender: (nominados) => {
          return <>{nominados > 0 && nominados} {nominados <= 0 && ' - '} </>
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'sinNominar',
      label: 'Sin nominar',
      options: {
        filter: false,
        sort: false,
        total: true,
        totalFloat: 'center',
        tooltipLabel: 'Cantidad sin nominar de los cupos asignados nominables',
        customBodyRender: (sinNominar) => {
          return <>{sinNominar > 0 && sinNominar} {sinNominar <= 0 && ' - '} </>
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        })
      }
    },
    {
      name: 'totalConsumidos',
      label: 'Consumidos',
      options: {
        filter: false,
        sort: false,
        total: true,
        totalFloat: 'center',
        tooltipLabel: 'Total de cupos nominados y libres consumidos',
        customBodyRender: (consumidos) => {
          return <>{consumidos > 0 && consumidos} {consumidos <= 0 && ' - '} </>
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'sinConsumir',
      label: 'Sin consumir',
      options: {
        filter: false,
        sort: false,
        total: true,
        totalFloat: 'center',
        tooltipLabel: 'Total de cupos nominados y libres sin consumir',
        customBodyRender: (sinConsumir) => {
          return <>{sinConsumir > 0 && sinConsumir} {sinConsumir <= 0 && ' - '} </>
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        })
      }
    },
    {
      name: 'cumplimientoConsumoCupo',
      label: 's/Asig',
      options: {
        filter: false,
        sort: false,
        tooltipLabel: 'Cupos consumidos sobre los nominados y los libres asignados',
        customBodyRender: cumplimiento => {
          return (cumplimiento > 0) ? <span style={{ fontWeight: 'bold' }}> {cumplimiento} % </span> : ' - '
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold',
            background: COLORES.grey.light
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: COLORES.grey.light
          }
        })
      }
    },
    {
      name: 'cumplimientoNominacion',
      label: 's/Nom',
      options: {
        filter: false,
        sort: false,
        tooltipLabel: 'Cantidad de cupos consumidos sobre los nominados',
        customBodyRender: cumplimiento => {
          return (cumplimiento > 0) ? <span style={{ fontWeight: 'bold' }}> {cumplimiento} % </span> : ' - '
        },
        setCellProps: () => ({
          style: {
            background: '#cecccc',
            textAlign: 'center',
            fontWeight: 'bold'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: '#cecccc'
          }
        })
      }
    },
    {
      name: 'cumplimientoAsignacion',
      label: 'Nom s/Asig',
      options: {
        filter: false,
        sort: false,
        tooltipLabel: 'Cantidad de nominados sobre los cupos asignados nominables',
        customBodyRender: cumplimiento => {
          return (cumplimiento > 0) ? <span style={{ fontWeight: 'bold' }}> {cumplimiento} % </span> : ' - '
        },
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontWeight: 'bold',
            background: COLORES.grey.light
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            background: COLORES.grey.light
          }
        })
      }
    }
  ])
}

export function getColumnasNominables (rol) {
  return ([
    {
      name: 'fechaCupo',
      label: 'Fecha',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => {
          return moment(fecha).format('DD-MM-YYYY')
        }

      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        setCellProps: () => ({
          style: {
            fontWeight: 'bold'
          }
        })
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        display: ((rol && rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR'))
      }
    },
    {
      name: 'cargador',
      label: 'Titular de cupo',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        display: ((rol && rol[0] !== 'CARGADOR' && rol[1] !== 'CARGADOR'))
      }
    },
    {
      name: 'cantidadNominada',
      label: 'Nominados',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (nominados) => {
          return <>{nominados > 0 && nominados} {nominados <= 0 && ' - '} </>
        }
      }
    },
    {
      name: 'cantidadConsumida',
      label: 'Consumidos',
      options: {
        filter: false,
        sort: false,
        total: true,
        customBodyRender: (consumidos) => {
          return <>{consumidos > 0 && consumidos} {consumidos <= 0 && ' - '} </>
        }
      }
    },
    {
      name: 'cumplimientoNominacion',
      label: 'Cumplimiento nominación',
      options: {
        filter: false,
        sort: true,
        customBodyRender: cumplimiento => {
          return (cumplimiento > 0) ? <span style={{ fontWeight: 'bold' }}> {cumplimiento} % </span> : ' - '
        }
      }
    }
  ])
}

export const CUMPLIMIENTO_CUPO_ASIGNADO_TO_PRINT = [
  {
    name: 'fechaCupo',
    label: 'Fecha',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 100,
    mantenerCase: true
  },
  {
    name: 'totalAsignados',
    label: 'Asignados',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cantidadNominada',
    label: 'Nominados',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'sinNominar',
    label: 'Sin Nominar',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'totalConsumidos',
    label: 'Consumidos',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'sinConsumir',
    label: 'Sin consumir',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'cumplimientoAsignacion',
    label: 'Cumplimiento asignación',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'cumplimientoNominacion',
    label: 'Cumplimiento nominación',
    width: 80,
    mantenerCase: true
  },
  {
    name: 'cumplimientoConsumoCupo',
    label: 'Cumplimiento consumo cupo',
    width: 80,
    mantenerCase: true
  }
]

export const CUMPLIMIENTO_CUPO_NOMINABLE_TO_PRINT = [
  {
    name: 'fechaCupo',
    label: 'Fecha',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'exportador',
    label: 'Exportador',
    width: 180,
    mantenerCase: true
  },
  {
    name: 'cargador',
    label: 'Titular de cupo',
    width: 180,
    mantenerCase: true
  },
  {
    name: 'cantidadNominada',
    label: 'Nominados',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cantidadConsumida',
    label: 'Consumidos',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'cumplimientoNominacion',
    label: 'Cumplimiento nominación',
    width: 80,
    mantenerCase: true
  }
]
